import React, { useEffect, useState } from 'react';
import PageTitle from '../../../jsx/layouts/PageTitle';
import useApi from '../../../hooks/useApi';
import { deleteMenuItem, getMenuList } from '../../../services/adminApiService/menuApi/MenuApiService';
import { useDeleteHandler } from '../../../hooks/useDeleteHandler';
import { RiDeleteBinLine } from "react-icons/ri";
import { DeleteAccountUser } from '../../../services/adminApiService/accountManagementApi/AccountManagementApiService';
import { useMenuManagement } from '../../../context/MenuManagementContext';
import { FaEdit, FaTrash, FaChevronDown, FaChevronRight } from "react-icons/fa";

const MenuManagementList = ({ handleOpenEdit, currentPage, perPage }) => {

    const { loading, menuDataList, fetchMenuList, setMenuId, menuId, fetchSidebarMenuList } = useMenuManagement();
    const [expanded, setExpanded] = useState({});

    const { handleDelete } = useDeleteHandler();

    const deleteHandler = (id) => {
        handleDelete({
            deleteApi: () => deleteMenuItem(id),
            refreshListApi: async () => {
                await fetchMenuList(perPage, currentPage);
                await fetchSidebarMenuList();
            },
            successMsg: "User Role deleted successfully"
        });
    };

    const handleDeleteParent = (id) => {
        if (window.confirm("Delete this menu and all submenus?")) {
            console.log("Delete Parent:", id);
        }
    };

    const handleDeleteChild = (id) => {
        if (window.confirm("Delete this submenu?")) {
            console.log("Delete Child:", id);
        }
    };

    const toggleExpand = (id) => {
        setExpanded((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };
    

   
    return (
        <>

            <div className="col-12">
                <div className=" filter-card-wrapper">

                    <div className="card-body">
                        {loading ? (
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>

                        ) : (

                            <div className="w-100 table-responsive">
                                <div id="example_wrapper" className="dataTables_wrapper">
                                    <form>
                                        <table id="example" className="display w-100 dataTable">
                                            <thead>
                                                <tr>
                                                    <th>SN</th>
                                                    <th>Parent Title</th>
                                                    <th>Icon</th>
                                                    <th>Url</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {menuDataList?.data?.map((menu, index) => {
                                                    console.log("menu===>",menu)
                                                    return (
                                                         <>
                                                        {/* Parent Row */}
                                                        <tr key={menu.id}>
                                                            <td>{index + 1 + (currentPage - 1) * perPage}</td>
                                                            <td>
                                                                <span
                                                                    onClick={() => toggleExpand(menu.id)}
                                                                    style={{ cursor: "pointer", marginRight: 8 }}
                                                                >
                                                                    {expanded[menu.id] ? <FaChevronDown /> : <FaChevronRight />}
                                                                </span>
                                                                {menu?.title}
                                                            </td>
                                                            <td>
                                                                <i className={menu.icon}></i>
                                                            </td>
                                                            <td>{menu?.url}</td>
                                                            <td>{menu?.status_label}</td>
                                                            <td>
                                                                <FaEdit
                                                                    className="text-primary me-3"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => handleOpenEdit(menu, menu?.id)}
                                                                />
                                                                <FaTrash
                                                                    className="text-danger"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => deleteHandler(menu?.id)}
                                                                />
                                                            </td>
                                                        </tr>

                                                        {/* Submenus */}
                                                        {expanded[menu.id] &&
                                                            menu.children?.map((child) => (
                                                                <tr key={child.id} style={{ background: "#f9f9f9" }}>
                                                                    <td></td>
                                                                    <td style={{ paddingLeft: "40px" }}>
                                                                        └ {child.title}
                                                                    </td>
                                                                    <td></td>
                                                                    <td>{child.url}</td>
                                                                     <td>{child?.status_label}</td>
                                                                    <td>
                                                                        <FaEdit
                                                                            className="text-primary me-3"
                                                                            style={{ cursor: "pointer" }}
                                                                             onClick={() => handleOpenEdit(child, child?.id)}
                                                                        />
                                                                        <FaTrash
                                                                            className="text-danger"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => deleteHandler(child.id)}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                    </>

                                                    )
                                                   
})}
                                            </tbody>
                                        </table>
                                    </form>
                                </div>
                            </div>

                        )}

                    </div>
                </div>


            </div>

        </>
    );
}

export default MenuManagementList;
